import { render, staticRenderFns } from "./ApplicationDetailsPage.vue?vue&type=template&id=6722502a"
import script from "./ApplicationDetailsPage.vue?vue&type=script&lang=js"
export * from "./ApplicationDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports